/**
 * Face Expression screen (face_expression tool): the shared style-template
 * screen with an intensity picker and a consent notice under the photo step.
 * See ./styleTool.ts.
 */
import { renderStyleTool } from './styleTool.js';
import { expressionOptions } from './toolOptions.js';

export function renderFaceExpression(root: HTMLElement, query: URLSearchParams): void {
  renderStyleTool(root, query, {
    tool: 'face_expression',
    title: 'Face Expression',
    subtitle: 'Change expressions naturally while keeping your face realistic.',
    stylesTitle: 'Choose an expression',
    seeAllHref: '#/category/face-expression',
    cta: 'Generate Expression',
    emptyIcon: 'mood',
    emptyText: 'No expressions are available yet. Please check back soon.',
    uploadNotice: 'Only use photos of yourself or people who agreed.',
    makeOptions: expressionOptions,
  });
}
